import { PlaygroundShape, PlaygroundShapeType } from '@/types/creator';
import { IconCircle, IconPolygon, IconRectangle } from '@tabler/icons-react';
import RENDERER_CONFIG from './rendererConfig';

const shapes: PlaygroundShape[] = [
	{
		id: '9246a188-ee93-455f-838b-e0b65b2f15c2',
		name: 'rectangle',
		type: PlaygroundShapeType.RECTANGLE,
		vertices: [
			[-10, -10],
			[-10, 10],
			[10, 10],
			[10, -10],
		],
		Icon: IconRectangle,
	},
	{
		id: '28fa9073-d8f9-4c69-82fc-82daa6210389',
		name: 'circle',
		type: PlaygroundShapeType.CIRCLE,
		radius: RENDERER_CONFIG.CIRCLE_SHAPE.DIAMETER.DEFAULT / 2,
		Icon: IconCircle,
	},
	{
		id: '7997b7e5-40c6-46ce-a785-28bfe1a9b703',
		name: 'custom',
		type: PlaygroundShapeType.CUSTOM,
		vertices: [],
		Icon: IconPolygon,
	},
];

export default shapes;
